import { Phone, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import heroImage from "@/assets/hero-dark-hardwood-enhanced.jpg";
import MagneticButton from "./MagneticButton";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-24">
      {/* Background Image - Using img for better LCP optimization */}
      <img
        src={heroImage}
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover object-bottom"
      />
      
      {/* Overlay */}
      <div className="hero-overlay" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-2xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-primary-foreground mb-6 text-shadow-lg leading-tight">
            Professional Hardwood & LVP Flooring Done Right
          </h1>
          
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-8 text-shadow leading-relaxed">
            Hardwood refinishing, installations, and LVP flooring by a locally owned business that takes pride in clean work, proper prep, and finishes that last.
          </p>
          
          <p className="text-base text-primary-foreground/70 mb-10 text-shadow">
            Serving Colorado Springs & Surrounding Areas
          </p>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <MagneticButton>
              <a
                href="tel:+17192327424"
                className="btn-cta-primary flex items-center justify-center gap-3 text-lg"
              >
                <Phone size={22} />
                Call for Free Estimate
              </a>
            </MagneticButton>
            <MagneticButton>
              <a
                href="sms:+17192327424"
                className="btn-cta-secondary flex items-center justify-center gap-3 text-lg"
              >
                <MessageSquare size={22} />
                Text Us
              </a>
            </MagneticButton>
          </div>
          
          {/* Secondary CTA */}
          <div className="mt-6">
            <Link
              to="/gallery"
              className="inline-flex items-center text-primary-foreground/80 hover:text-primary-foreground font-heading uppercase tracking-wide text-sm transition-colors underline underline-offset-4"
            >
              View Recent Work →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
